import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useState } from 'react';

// Same as useIsBrowser, but uses useLayoutEffect so the flag flips before the
// browser paints. Prefer this when the mounted/browser value affects what the
// user sees on first paint (e.g. floating labels, prefilled form fields), to
// avoid a visible flash of incorrect content.
//
// During the initial render it returns false in both browser and server
// environments, which prevents SSR hydration errors.
//
// Prefer useIsBrowser when the browser-only behavior does not affect initial
// layout, since useLayoutEffect can emit React SSR warnings in server logs.

const useIsBrowserLayout = () => {
  const $ = _c(2);
  const [isBrowser, setIsBrowser] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsBrowser(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useLayoutEffect(t0, t1);
  return isBrowser;
};
export default useIsBrowserLayout;